module.exports = loadPath => () => import(`@/${loadPath}.vue`);



// WEBPACK FOOTER //
// ./src/configure/router/import/_import_production.js